export const SAVE_OR_EDIT_BATCH_NOTE_REQUEST = 'SAVE_OR_EDIT_BATCH_NOTE_REQUEST';
export const saveOrEditBatchNoteRequest = (batchId, name, note, assignedToGuid) => ({
  type: SAVE_OR_EDIT_BATCH_NOTE_REQUEST,
  batchId,
  name,
  note,
  assignedToGuid,
});

export const SAVE_OR_EDIT_BATCH_NOTE_SUCCESS = 'SAVE_OR_EDIT_BATCH_NOTE_SUCCESS';
export const saveOrEditBatchNoteSuccess = (batchId, note) => ({
  type: SAVE_OR_EDIT_BATCH_NOTE_SUCCESS,
  batchId,
  note,
});
